<script>
/* import { tableData } from './data-advance' */
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import Dialog from '@components/dialogs'
import error from '@utils/error'

export default {
  props:['type'],
	data() {
		return {
			title: this.$t('company.plural'),
			items: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: 'name',
			sortDesc: false,
			fields: [
				{ key: 'name', label:this.$t('company.table.name'), sortable: true},
        { key: 'total_jobs', label: this.$t('company.table.total_jobs'), sortable: true},
        { key:'date_created', label: this.$t('company.table.date_created'), formatter: (value) => {
            return moment(value).format('YYYY-MM-DD')
          },
          sortable: true
        },
        {key:'actions',label:''}
      ],
      isBusy:false,
      rowId: ''
		}
	},
  component: {
    Dialog
  },
	computed: {
		rows() {
			return this.totalRows
		},
    updateComponent() {
      return () => import('../pages/company/components/dialogs/edit.vue')
    }
	},
	mounted() {
    this.fetchData()
	},
	methods: {
		...mapActions('company', ['pagination', 'getVincereCompany']),
    sortChange(sortValue){
      this.sortBy = sortValue.sortBy
      this.sortDesc = sortValue.sortDesc
      this.fetchData().catch(error => {
        console.error(error)
      })
    },
    filterList(){
      this.fetchData()
    },
    syncCompanies(){
      this.toggleBusy()
      this.getVincereCompany(this.model).then(res => {
        if(res.data.status){
          this.fetchData(true)
        }
			}).catch(err => {
        console.log(err);
        return error.errorHandler(err, this.$bvToast)
			})
    },
    onClickActions(ref, val) {
      this.$emit('onClick', { ref, val })
    },
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    async fetchData(reload = false, type = 'active', useProps = true) {
      if(this.role_modules.some(item => item.value == 'company')){
        if(!reload){
          this.toggleBusy()
        }

        let skip = this.currentPage <= 1 ? 0 : (this.currentPage - 1) * this.perPage

        if(useProps)
          type = this.type

        await this.pagination({
          limit:this.perPage,
          start: skip,
          company_id: this.company_id,
          filter: this.filter,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
          type: type
        })
        .then(res => {
          this.totalRows = parseInt(res.data.total, 10)
          this.items = res.data.data
          this.toggleBusy()
        })
      }
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    companyImage(company) {
      if(company.avatar_path) {
        var http = new XMLHttpRequest();
        http.open('HEAD', company.avatar_path, false);
        http.send();

        if(http.status != 404){
          return company.avatar_path
        }
      }

      return company.img_url
		}
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex mb-md-2 justify-content-end">
            <!-- Search -->
            <div class="">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                    @keydown.enter.native="filterList"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter-included-fields="filterOn"
              :show-empty="true"
              @filtered="onFiltered"
              @sort-changed="sortChange"
            >
              <!-- <template v-slot:cell(avatar)="row">
                <img 
                  :src="row.item.avatar_path" 
                  alt="avatar" 
                  class="avatar-sm rounded-rounder mr-2">
              </template> -->
            
              <template v-slot:cell(actions)="row" v-if="user.role.role == 'administration'">
                <button
                  @click="onClickActions('viewCompany', row.item)"
                  class="btn2 btn2-primary btn-sm mx-1 mb-1"
                  v-if="role_modules.some(item => item.value == 'company.view')"
                >
                  <i class="uil uil-eye"></i>
                </button>
                <button
                  @click="onClickActions('updateCompany', row.item)"
                  class="btn2 btn2-primary btn-sm mx-1 mb-1"
                  v-if="role_modules.some(item => item.value == 'company.edit')"
                >
                  <i class="uil uil-edit"></i>
                </button>
                <button
                  @click="$emit('onActivate', row.item)"
                  class="btn2 btn2-primary btn-sm mx-1 mb-1"
                  v-if="role_modules.some(item => item.value == 'company.delete')"
                >
                  <i class="uil uil-times-circle"></i>
                </button>
              </template>

              <template v-slot:cell(name)="row">

                <div class="d-flex align-items-center">
                  <img 
                    :src="row.item.avatar_path ? row.item.avatar_path : row.item.img_url" 
                    alt="avatar" 
                    class="avatar-md rounded-lg mr-3"
                  >
                  <div class="">
                    <button 
                      class="btn2 btn2-tertiary h6"
                      style="padding: 0px !important;margin: 0px !important;"
                      @click="onClickActions('viewCompany', row.item)"
                    >
                      {{ row.item.name }}
                    </button>

                    <p class="text-muted"  style="margin: 0px !important;">{{ row.item.email }}</p>
                  </div>
                </div>

                
              </template>


              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="d-flex mb-md-2 justify-content-end">
            <div class="">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span>{{ $t('common.show') }}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{ $t('common.entries') }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .link_row {
    cursor: pointer;
    transition: color 0.3s;
  }

  .link_row:hover {
    color: blue;
  }
</style>